__turbopack_context__.v({
  "about": "collection-object-package-page-module-scss-module__U6GY_a__about",
  "filters": "collection-object-package-page-module-scss-module__U6GY_a__filters",
  "objectsViewerWrapper": "collection-object-package-page-module-scss-module__U6GY_a__objectsViewerWrapper",
  "researchLink": "collection-object-package-page-module-scss-module__U6GY_a__researchLink",
  "researchLinksInfo": "collection-object-package-page-module-scss-module__U6GY_a__researchLinksInfo",
  "tabBodyWrapper": "collection-object-package-page-module-scss-module__U6GY_a__tabBodyWrapper",
  "tabPanelContent": "collection-object-package-page-module-scss-module__U6GY_a__tabPanelContent",
});
